import axios, { AxiosInstance } from 'axios'

const origin = window.location.origin

export type AggregateViewType = 'crew' | 'job'

export const CREW_RESOURCE_URL = origin + '/services/plugin-frac-lts/crew'
export const JOB_RESOURCE_URL = origin + '/services/plugin-frac-lts/job'

const crewAggregateInstance: AxiosInstance = axios.create({
    baseURL: `${CREW_RESOURCE_URL}/aggregateStages`,
    headers: { 'Content-Type': 'application/json' }
})

const jobAggregateInstance: AxiosInstance = axios.create({
    baseURL: `${JOB_RESOURCE_URL}/aggregateStages`,
    headers: { 'Content-Type': 'application/json' }
})

export const getAggregateStagesInstance = (viewType: AggregateViewType): AxiosInstance => {
    return viewType === 'job' ? jobAggregateInstance : crewAggregateInstance
}
